import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";

export const MODULE = "POD";
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $upload = ActionCreator.Async(MODULE, "Upload", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/shipment/${id}/complete`, payload)
      .then((response) => {
        dispatch($upload.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $savePhoto = ActionCreator.Default(
  MODULE,
  "savePhoto",
  (payload) => {
    return async (dispatch) => {
      dispatch($savePhoto.action({ payload }));
      return;
    };
  }
);
